import React from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'

import { getCurrentVenueTimezone } from '../../store/Venues/selector'
import { makeGetSalesEvent } from '../../store/Event/selector'
import { parseTimezone } from '../../utils/parseTimezone'

import SuitesEventDetails from '../../containers/Event/Details'
import Layout from '../../components/Layout'

export const EventDetails = ({
  currentVenueTimezone,
  event,
  eventId,
  history,
}) => {
  const eventStartTime = parseTimezone(event?.startTime, currentVenueTimezone)
  const backTo = {
    pathname: '/events',
    state: {
      selectedEventId: eventId
    }
  }

  return (
    <Layout
      backTo={backTo}
      iconType='back'
      isSidebar={true}
      title={event.name}
      subtitle={eventStartTime}
      event={event}
    >
      <SuitesEventDetails history={history} />
    </Layout>
  )
}

const mapStateToProps = (state, ownProps) => {
  const currentVenueTimezone = getCurrentVenueTimezone(state)
  const eventId = get(ownProps, 'match.params.eventId')
  const getSalesEvent = makeGetSalesEvent()

  const salesEvent = getSalesEvent(state, eventId)

  return {
    currentVenueTimezone,
    event: salesEvent,
    eventId,
  }
}

export default connect(mapStateToProps, null)(EventDetails)
